import React from "react";
import "../navbar.css";
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    const goToHome = (route) => {
        navigate("/" + route);
    };
    return (
            <div className="footer">
                <div className="footersection">
                    <div className="footerlinks">
                        <div className="footerlinks-1">
                            <h2>COMPANY</h2>

                            <a href="https://www.purina.com/privacy-policy">
                                PRIVACY POLICY
                            </a>

                            <a href="https://www.purina.com/terms-of-sale">
                                TERMS OF SALES
                            </a>

                            <a href="https://www.purina.com/cookie-policy">
                                COOKIE POLICY
                            </a>

                            <a href="https://www.purina.com/privacy-policy#notice-at-collection">
                                NOTICE AT COLLECTION
                            </a>
                            <a href="https://www.purina.com/do-not-sell-or-share-my-personal-information">DO NOT SELL OR SHARE MY PERSONAL INFORMATION</a>

                            <a href="https://www.purina.com/about/supply-chains-act">
                                SUPPLY CHAIN ACT
                            </a>
                            <a href="https://www.purina.com/terms-and-conditions">
                                TERMS & CONDITIONS
                            </a>
                        </div>

                        <div className="footerlinks-1">
                            <h2>QUICK LINKS</h2>

                            <a href="#home" onClick={(e) => { e.preventDefault(); goToHome("home"); }} style={{ cursor: 'pointer' }}>
                                HOME
                            </a>

                            <a href="#register" onClick={(e) => { e.preventDefault(); goToHome("registerpage"); }} style={{ cursor: 'pointer' }}>
                                REGISTER
                            </a>
                        </div>

                        <div className="footerlinks-1">
                            <h2>INFORMATION</h2>

                            <a href="https://petivitybrands.myshopify.com/pages/contact">
                                CONTACT
                            </a>

                            <a href="https://petivitybrands.myshopify.com/pages/how-it-works">
                                HOW IT WORKS
                            </a>
                        </div>
                    </div>
                </div>              
            </div>
    );
}
export default Footer;
